import { render, staticRenderFns } from "./ui-progress-ring-component.vue?vue&type=template&id=5acdf6cd&scoped=true&"
import script from "./ui-progress-ring-component.vue?vue&type=script&lang=ts&"
export * from "./ui-progress-ring-component.vue?vue&type=script&lang=ts&"
import style0 from "./ui-progress-ring-component.vue?vue&type=style&index=0&id=5acdf6cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acdf6cd",
  null
  
)

export default component.exports